export function AnimatedBackground() {
  return (
    <div className="ambient-background" aria-hidden="true">
      <div className="ambient-background__mirror" />
      {[0, 1, 2, 3, 4].map(index => (
        <span
          key={index}
          className={`ambient-background__orb ambient-background__orb--${index + 1}`}
        />
      ))}
      <div className="ambient-background__flare ambient-background__flare--left" />
      <div className="ambient-background__flare ambient-background__flare--right" />
      <div className="ambient-background__grain" />
    </div>
  )
}
